import Vue from 'vue'

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    GET_STATS: ({ rootState }, { userId, startDate, endDate }) =>
      new Promise((resolve, reject) => {
        const url = userId
          ? `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/onDuty/stats/${userId}`
          : `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/onDuty/stats`

        Vue.prototype.$http
          .get(url, { params: { startDate, endDate } })
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_HISTORY: ({ rootState }, { userId, pageNumber, pageSize, orderBy, orderDir, startDate, endDate, search }) =>
      new Promise((resolve, reject) => {
        const url = userId
          ? `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/onDuty/history/${userId}`
          : `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/onDuty/history`

        Vue.prototype.$http
          .get(url, { params: { pageNumber, pageSize, orderBy, orderDir, startDate, endDate, search } })
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
    GET_DISCORD_MEMBER: ({ rootState }, { userId }) =>
      new Promise((resolve, reject) => {
        Vue.prototype.$http
          .get(
            `/v1/communities/${rootState.selection.community.id}/services/${rootState.selection.service.id}/discord/members/${userId}`,
          )
          .then(res => {
            resolve(res)
          })
          .catch(err => reject(err))
      }),
  },
}
